import { render, staticRenderFns } from "./adminPermissionRule.vue?vue&type=template&id=3944a7a4&scoped=true&"
import script from "./adminPermissionRule.vue?vue&type=script&lang=js&"
export * from "./adminPermissionRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3944a7a4",
  null
  
)

export default component.exports